import { useEffect, useState } from 'react';
import useClient from 'api/client';
import { useAlert } from 'components/message/AlertContext';
import { useParams } from 'react-router-dom';
import { FormatDate } from 'components/dates/FormatDate';
import getSqlPipeline from 'api/SqlPipeline/getSqlPipeline';
import { Pipeline } from 'types/Pipeline';

export default function usePipeline() {
    const client = useClient();
    const { openAlert } = useAlert();
    const params = useParams<{ uri: string }>();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    // TODO: cleanup the pipeline object once the entire pipeline is implemented
    const [pipeline, setPipeline] = useState<Pipeline>({
        sqlPipelineUri: '',
        created: '',
        pipelineStageOptions: '',
        userRoleForPipeline: '',
        repo: '',
        label: '',
        stack: {
            resources: '',
            status: '',
            stackUri: '',
            region: '',
            accountid: '',
            link: '',
            stack: '',
            stackid: '',
        },
        environment: {
            environmentUri: '',
            AwsAccountId: '',
            region: '',
        },
        runs: [
            {
                Id: '',
                StartedOn: '',
                JobRunState: '',
            },
        ],
    });

    const fetchData = async () => {
        try {
            if (params.uri) {
                setLoading(true);
                const response = await client?.query(
                    getSqlPipeline(params.uri),
                );
                if (!response.errors) {
                    setPipeline({
                        ...response.data.getSqlPipeline,
                        created: FormatDate(
                            response.data.getSqlPipeline.created,
                        ),
                    });
                } else {
                    setError(true);
                    openAlert({
                        message:
                            'Something went wrong... Could not retrieve pipeline',
                        severity: 'alert',
                    });
                }
            }
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        if (client) {
            fetchData();
        }
    }, [client, params.uri]);

    return {
        pipeline,
        error,
        loading,
        fetchData,
    };
}
